<template>
    <v-form-control :field="field">
        <template scope="api">
            <v-autosuggest
                v-if="items !== undefined && !multiple"
                :value="api.getValue()" 
                :select="select" 
                :items="items" 
                :name="field" 
                :readonly="api.isReadonly() || readonly" 
                @input="api.setValue($event); $emit('input', $event)"
                @blur="api.setTouched" 
                :caption="caption" 
                :label="labelWithRequired"
                :error="api.getTouched() ? api.getError() : undefined" 
                :placeholder="placeholder" 
                :type="type"
                :getItemValue="getItemValue"
                :getItemId="getItemId"
                :getItemCaption="getItemCaption"
                :maxlength="maxlength"
                :multiple="multiple"
            />
            <v-input-multiple
                v-if="items !== undefined && multiple"
                :value="api.getValue()"
                :label="labelWithRequired"
                :placeholder="placeholder"
                :caption="caption"
                :error="api.getTouched() ? api.getError() : undefined"
                :name="field"
                :items="items"
                :maxlength="maxlength"
                :maxSelectItems="maxSelectItems"
                :altItem="altItem"
                @input="api.setValue($event); $emit('input', $event)"
                @blur="api.setTouched"
            />
            <v-input-text
                v-if="items === undefined && !multiple"
                :type="type"
                :value="api.getValue()" 
                :name="field"
                :autocomplete="autocomplete"
                @input="api.setValue($event); $emit('input', $event)"
                @blur="api.setTouched"
                :readonly="api.isReadonly() || readonly" 
                :disabled="disabled" 
                :multiline="multiline" 
                :mask="mask" 
                :maxlength="maxlength" 
                :caption="caption" 
                :label="labelWithRequired"
                :error="api.getTouched() ? api.getError() : undefined" 
                :placeholder="placeholder" 
            >
                <template v-if="!error" slot="error" scope="props">
                    <slot name="error">{{ props.error }}</slot>
                </template>
                <template v-if="!caption" slot="caption" scope="props">
                    <slot name="caption">{{ props.caption }}</slot>
                </template>
            </v-input-text>
        </template>
    </v-form-control>
</template>
<script>
    export default {
        name: 'form-input',
        props: {
            items: Array,
            getItemValue: Function,
            getItemId: Function,
            filterSuggestion: Function,
            getItemCaption: Function,
            label: String,
            mask: String,
            autocomplete: String,
            placeholder: String,
            multiline: Boolean,
            readonly: Boolean,
            disabled: Boolean,
            select: Boolean,
            required: Boolean,
            caption: String,
            error: String,
            maxSelectItems: Number,
            altItem: Object,
            maxlength: [String, Number],
            type: String,
            multiple: Boolean,
            field: {
                type: String,
                required: true,
            }
        },
        computed: {
            labelWithRequired() {
                return this.label && this.required
                    ? this.label + ' *'
                    : this.label;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// FormInput.vue?ef7583ea